// Register a global custom directive called v-focus
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus();
  }
});

Vue.directive('can', (el, binding, vnode) => {
    let self= vnode.context;
    switch (binding.arg){
        case 'access':
            if(!self.canAccessRoute(binding.value)) {
                commentNode(el, vnode);
            }
            break;
        case 'route':
            if(!self.canAccessRoute(vnode.componentInstance.to)) {
                commentNode(el, vnode);
            }else{
                uncommentNode(el, vnode);
            }
            break;
        default:
            if(!self.hasPermissionInCompany(binding.value, binding.arg)){
                //el.style.display = 'none';
                commentNode(el, vnode);
            }
            break;
    }
});

window.commentNode = (el, vnode)=>{
    const comment = document.createComment(' ');
    Object.defineProperty(comment, 'setAttribute', {
        value: () => undefined,
    });
    // O Vue continua chamando os patch hooks (updateStyle/updateAttrs) sobre este vnode
    // mesmo apos viramos o elm em comentario. Comentarios nao tem .style, entao
    // updateStyle faria `comment.style.fontSize = ...` -> "Cannot set properties of
    // undefined (setting 'fontSize')". Damos um style stub que absorve as escritas
    // (sem efeito visual, pois o comentario nao e renderizado).
    if (!comment.style) {
        Object.defineProperty(comment, 'style', {
            value: { setProperty() {}, removeProperty() {} },
            configurable: true,
        });
    }
     vnode.elm = comment;
    // vnode.text = ' ';
    // vnode.isComment = true;
    // vnode.context = undefined;
    // vnode.tag = undefined;
    // vnode.data.directives = undefined;
    //
    // if (vnode.componentInstance) {
    //     vnode.componentInstance.$destroy();
    //     //vnode.componentInstance.$el = comment;
    // }

    el.replaceWith(comment);

    // if (el.parentNode) {
    //     el.parentNode.replaceChild(comment, el);
    // }

};

window.uncommentNode = (el, vnode)=>{
    //console.log(vnode, vnode.componentInstance.$el, vnode.componentInstance.$el.parentNode);
    if(vnode.componentInstance) {
        vnode.elm = vnode.componentInstance.$el;
        el.replaceWith(vnode.componentInstance.$el);
    }
    //console.log(vnode, vnode.elm.parentNode, el);

};

import masker from './masker';
Vue.use(masker);